import {
  ADMINISTRATORLIST_FETCHITEMS_LOAD,
  ADMINISTRATORLIST_FETCHITEMS_SUCCEED,
  ADMINISTRATORLIST_FETCHITEMS_FAIL,
  ADMINISTRATORLIST_CHANGETABLE_CHANGE,
  ADMINISTRATORLIST_SEARCHTABLE_EDIT,
  ADMINISTRATORLIST_SEARCHTABLE_SEARCH,
} from '../constants/actionTypes'

export default (state = {}, action) => {
  switch (action.type) {
    case ADMINISTRATORLIST_FETCHITEMS_LOAD:
      return { ...state, isFetchItemsLoading: true, fetchItemsError: null }
    case ADMINISTRATORLIST_FETCHITEMS_SUCCEED:
      return {
        ...state,
        isFetchItemsLoading: false,
        items: action.items,
        pagination: { ...state.pagination, total: action.total },
      }
    case ADMINISTRATORLIST_FETCHITEMS_FAIL:
      return {
        ...state,
        isFetchItemsLoading: false,
        items: null,
        fetchItemsError: action.fetchItemsError,
      }
    case ADMINISTRATORLIST_CHANGETABLE_CHANGE: {
      return {
        ...state,
        pagination: action.pagination,
        filters: action.filters,
        sorter: action.sorter,
      }
    }
    case ADMINISTRATORLIST_SEARCHTABLE_EDIT:
      return {
        ...state,
        search: action.search,
      }
    case ADMINISTRATORLIST_SEARCHTABLE_SEARCH:
      return {
        ...state,
        isSearching: action.isSearching,
      }
    default:
      return state
  }
}
